import { SelectBox } from '../../../base/SelectBox';
import { useLookupProductType } from '../useLookupProductType';

type IComboBoxProductTypeProps = {
	name: string;
	value: any;
	valueExpr?: string;
	displayExpr?: string;
	onValueChanged: (value: any) => void;
	label?: string;
	error?: string;
	sizeClass?: 'xs' | 'sm' | 'md' | 'lg';
	helpBlock?: string;
	labelSmall?: boolean;
	isDisabled?: boolean;
	hasValid?: boolean;
	placeholder?: string;
};

const ComboBoxProductType = (props: IComboBoxProductTypeProps) => {
	const { product_type_all } = useLookupProductType();

	return (
		<SelectBox
			dataSource={product_type_all}
			valueExpr={'id'}
			displayExpr={'name'}
			{...props}
			placeholder={props.placeholder || 'Chọn danh mục'}
			isClearable={true}
		/>
	);
};
export default ComboBoxProductType;